import React, { useEffect, useState, useRef, useCallback } from "react";
import './ParaFacturacion.scss';
import FiltrosParaFacturacion from "./partes/Filtros";
import { formateoBasico } from "../../../utilidades/formateos";
import { getServiciosFacturacion, getServiciosFacturacionNoEjecutados, editarServiciosFacturacion } from "./integracion";
import Tabla from "./partes/Tabla";
import { modalLoading, closeModalLoading } from "../../../components/atoms/ModalLoading/loadingModal";
import useGetDataUser from "../../../utilidades/customHooks/useGetDataUser";

const ParaFacturacion = () => {
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const [cliente, setCliente] = useState({ name: 'SUMA TE LLEVA', code: 5 });
    const [servicios, setServicios] = useState([]);
    const [serviciosNoEjecutados, setServiciosNoEjecutados] = useState([]);
    const [buscando, setBuscando] = useState(false);
    const [cargando, setCargando] = useState(false);
    const paramRef = useRef(null);
    const userData = useGetDataUser();
    const cargarDatos = useCallback((param) => {
        setCargando(true);
        modalLoading("Cargando servicios");
        Promise.all([
            getServiciosFacturacionNoEjecutados(param),
            getServiciosFacturacion(param),
        ]).then(([noEjec, ejec]) => {
            setServiciosNoEjecutados(noEjec);
            setServicios(ejec);
        }).catch((error) => {
            console.error("Error al obtener los servicios de facturación:", error);
        }).finally(() => {
            setCargando(false);
            closeModalLoading();
        });
    }, []);

    const handleGuardar = useCallback(async (apiPayload) => {
        if (!apiPayload?.length) return;
        try {
            modalLoading("Guardando cambios");
            await editarServiciosFacturacion(apiPayload, userData?.user?.ID);
            if (paramRef.current) {
                await Promise.all([
                    getServiciosFacturacion(paramRef.current).then(setServicios),
                    getServiciosFacturacionNoEjecutados(paramRef.current).then(setServiciosNoEjecutados),
                ]);
            }
        } catch (error) {
            console.error("Error al guardar el servicio:", error);
        } finally {
            closeModalLoading();
        }
    }, [userData]);

    
    useEffect(() => {
        if(!fechaInicio || !fechaFin || !cliente) return;
        const param = {
            fechaInicio: formateoBasico(fechaInicio),
            fechaFin: formateoBasico(fechaFin),
            idCliente: cliente?.code || 5,
        }
        paramRef.current = param;
        cargarDatos(param);
    }, [buscando])
    return (
        <div className="paraFacturacion">
            <FiltrosParaFacturacion
                fechaInicio={fechaInicio}
                setFechaInicio={setFechaInicio}
                fechaFin={fechaFin}
                setFechaFin={setFechaFin}
                cliente={cliente}
                setCliente={setCliente}
                onBuscar={()=>{setBuscando(!buscando)}}
            />
            <Tabla data={servicios} noEjecutados={serviciosNoEjecutados} onGuardar={handleGuardar} />
           
        </div>
    );
};

export default ParaFacturacion;